import type {BranchPickerBranch} from '@github-ui/item-picker-branch/BranchPicker'
import {GitBranchIcon} from '@primer/octicons-react'
import {ActionList} from '@primer/react'

import {LABELS} from '../../../constants/labels'
import {TEST_IDS} from '../../../constants/test-ids'
import {VALUES} from '../../../constants/values'
import {isPendingLinkedBranchId} from '../../../mutations/create-linked-branch-mutation'
import styles from './LinkedBranches.module.css'

type LinkedBranchesProps = {
  linkedBranches: BranchPickerBranch[]
}

export function LinkedBranches({linkedBranches}: LinkedBranchesProps) {
  return (
    <>
      {linkedBranches.map(branch => {
        if (isPendingLinkedBranchId(branch.id)) {
          return (
            <ActionList.Item
              key={branch.id}
              disabled
              data-testid={TEST_IDS.pendingLinkedBranch}
              className={styles.ActionList_LinkItem}
            >
              <ActionList.LeadingVisual className={styles.ActionList_LeadingVisual}>
                <GitBranchIcon />
              </ActionList.LeadingVisual>
              {branch.name}
              <ActionList.Description variant="block">
                {LABELS.development.creatingBranch(branch.repository.nameWithOwner)}
              </ActionList.Description>
            </ActionList.Item>
          )
        }

        return (
          <ActionList.LinkItem
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            href={VALUES.branchUrl(branch.name, branch.repository.nameWithOwner!)}
            target="_blank"
            key={branch.id}
            className={styles.ActionList_LinkItem}
          >
            <ActionList.LeadingVisual className={styles.ActionList_LeadingVisual}>
              <GitBranchIcon />
            </ActionList.LeadingVisual>
            {branch.name}
            <ActionList.Description variant="block">{branch.repository.nameWithOwner}</ActionList.Description>
          </ActionList.LinkItem>
        )
      })}
    </>
  )
}
